export const AppRoutes = {
  HOME: '',
  PORTAL_WIDGET: 'widget',
  PORTAL_WIDGET_PREVIEW: 'portal-widget-preview',
  JOIN_PLATFORM: 'join-platform',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  RESTAURANTS: {
    ROOT: 'restaurants',
    RESTAURANT_ID: 'restaurantId',
    RESERVATION: 'reservation',

    DETAILS: (restaurantId: string) => `/${AppRoutes.RESTAURANTS.ROOT}/${restaurantId}`,
    RESERVATION_CREATE: (restaurantId: string) =>
      `/${AppRoutes.RESTAURANTS.ROOT}/${restaurantId}/${AppRoutes.RESTAURANTS.RESERVATION}`,
  },
};
